import React from "react";

const Cards = ({ items }) => {
  return (
    <div className="GridContainer grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
      {items.map((item, index) => (
        <div
          key={index}
          className="bg-white shadow-lg rounded-lg p-6 relative flex flex-col items-start r lg:items-start"
        >
          <h1 className="text-primaryTextColor text-[24px] sm:text-[28px] font-bold tracking-wider">
            {item.numberOfItems}
          </h1>
          <p className="text-secondaryTextColor text-[14px] sm:text-[15px] tracking-wide">
            {item.name}
          </p>
          <img
            src={item.icon}
            alt="card-img"
            className="absolute top-4 right-4 h-[40px] w-[40px] sm:h-[50px] sm:w-[50px]"
          />
        </div>
      ))}
    </div>
  );
};

export default Cards;
